module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrows-angle-contract-0b59377d.svg";